export enum HubAccountType {
  EZLO_HUB = 'ezlo_hub',
  EZLO_WIFI_HUB = 'ezlo_wifi_hub',
  PEPLINK_HUB = 'peplink_hub',
  ADC_HUB = 'adc_hub',
  SMART_LOCK = 'smart_lock',
  SCHLAGE = 'schlage',
  SCHLAGE_STAGING = 'schlage_staging',
  SCHLAGE_PILOT = 'schlage_pilot',
}

export const HUB_ACCOUNT_TYPE = [
  {
    value: HubAccountType.EZLO_HUB,
    label: 'Ezlo Hub',
  },
  {
    value: HubAccountType.EZLO_WIFI_HUB,
    label: 'Ezlo Wifi Hub',
  },
  {
    value: HubAccountType.PEPLINK_HUB,
    label: 'Peplink Hub',
  },
  {
    value: HubAccountType.ADC_HUB,
    label: 'ADC Hub',
  },
  {
    value: HubAccountType.SMART_LOCK,
    label: 'Smart Lock',
  },
  {
    value: HubAccountType.SCHLAGE,
    label: 'Schlage',
  },
  {
    value: HubAccountType.SCHLAGE_STAGING,
    label: 'Schlage (Staging)',
  },
  {
    value: HubAccountType.SCHLAGE_PILOT,
    label: 'Schlage (Pilot)',
  },
];

export const isSchlageAccountType = (accountType?: string) => (
  accountType === HubAccountType.SCHLAGE
  || accountType === HubAccountType.SCHLAGE_STAGING
  || accountType === HubAccountType.SCHLAGE_PILOT
);

export const isManagedSchlageAccountType = (accountType?: string) => (
  accountType === HubAccountType.SCHLAGE_STAGING
  || accountType === HubAccountType.SCHLAGE_PILOT
);

export const getSchlageAuthUrl = (
  baseUrl: string,
  returnUrl: string,
  accountType?: string,
) => {
  let environment: string | undefined;
  if (accountType === HubAccountType.SCHLAGE_STAGING) {
    environment = 'stage';
  } else if (accountType === HubAccountType.SCHLAGE_PILOT) {
    environment = 'pilot';
  }

  const callbackPath = environment ? `/schlage/${environment}/auth` : '/schlage/auth';
  const envParam = environment ? `&env=${environment}` : '';
  const callbackUrl = `${baseUrl}${callbackPath}`;
  const redirectUri = encodeURIComponent(callbackUrl);

  return `${baseUrl}/schlage/auth/url?state=${encodeURIComponent(returnUrl)}&redirectUri=${redirectUri}${envParam}`;
};

